export default __webpack_public_path__ + "static/media/baby.d4f85216.png";